import { toastr } from 'react-redux-toastr';
import storageManager from './localStorage';
import { AUTH_STORAGE_KEY } from './apiAuthToken';

// During the logout / password-change transition, in-flight dashboard requests
// fail (token revoked or cleared) and their catch blocks run while a stale token
// may still be in storage — racing the logout. Opening a short suppression
// window silences those API-error toasts regardless of token state.
let suppressUntil = 0;
export const suppressApiErrorsFor = (ms: number): void => {
  suppressUntil = Date.now() + ms;
};

// Show an API-failure toast only when the user is logged in AND we're not in a
// logout/transition suppression window. Avoids alarming "failed to load X"
// toasts on the login screen after logout.
export const notifyApiError = (title: string, message: string): void => {
  if (Date.now() < suppressUntil) {
    return;
  }
  const auth = storageManager.get(AUTH_STORAGE_KEY);
  const isLoggedIn = !!(auth && auth.idToken && auth.idToken.jwtToken);
  if (isLoggedIn) {
    toastr.error(title, message);
  }
};
